import { createDivIn, createImgIn, createParagraphIn, createSpanIn, setElementInnerHTML, setElementOnClick } from '../../ui_utils/DomUtils.ts';
import { LobbyImage } from '@colonist/types';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
import { clientI18n } from '../../ClientI18n.ts';
import { BotDifficulty } from '@colonist/game-base-types';
import { PlayerColor } from '@colonist/game-states';
import { getLobbyImagePath } from '../../ui_utils/Utils.ts';
import { showChangeUsernameDialog } from '../../ui_popup/change_username_dialog/showChangeUsernameDialog.ts';
import { UIRoomUserList } from './UIRoomUserList.ts';
import { createTooltipIn, updateTooltipText } from '../../ui_utils/TooltipUtils.ts';
import IconHourglass from '@static/images/icon_hourglass.svg';
import { UIImagePathController } from '../../UIEnums.ts';
import { socket } from '../../EntryShared.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { SegmentedControl } from '@colonist/ui';
import { mountUIReactComponent } from '../../ui_platform/mountUIReactComponent.tsx';
export class UIRoomUserView {
    renderUserInfo() {
        this.profilePic = UIRoomUserView.createIconIn(this.nameContainer, LobbyImage.Guest, this.PLAYER_ICON_SIZE);
        this.usernameAndKarmaContainer = createDivIn(this.nameContainer, 'room_player_username_and_karma');
        this.usernameContainer = createDivIn(this.usernameAndKarmaContainer, 'room_player_username_container');
        this.userName = createSpanIn(this.usernameContainer, 'room_player_username', {
            key: 'strings:profilePage.friends.tableHeaders.player'
        });
        this.renderUsernameInfoIcon();
        this.karmaContainer = createDivIn(this.usernameAndKarmaContainer, 'room_player_karma');
        this.renderKarma();
    }
    renderUsernameInfoIcon() {
        this.usernameInfoIcon = createDivIn(this.usernameContainer, 'room_player_username_info_icon');
        UIRoomUserView.createIconIn(this.usernameInfoIcon, LobbyImage.InfoIcon, this.ICON_SIZE);
        createTooltipIn(this.usernameInfoIcon, {
            key: 'strings:roomPage.onlineUsernameTooltip'
        });
        setElementOnClick(this.usernameInfoIcon, ()=>{
            showChangeUsernameDialog();
        }, false, true);
        this.hideUsernameInfoIcon();
    }
    renderKarma() {
        this.karmaText = createParagraphIn(this.karmaContainer, {
            key: 'strings:colonistCommon.utils.emptyString'
        }, 'room_player_karma_text');
        createTooltipIn(this.karmaContainer, {
            key: 'strings:homePage.overview.karma'
        }, undefined, undefined, 'small');
        setElementOnClick(this.karmaContainer, ()=>undefined, false, true);
    }
    createBotDifficultyControl() {
        this.difficultyContainer = createDivIn(this.colorAndDifficultyRow, 'room_player_difficulty hidden');
        const segmentedControlId = `room-bot-difficulty-segmentedcontrol-${UIRoomUserView.nextViewId}`;
        UIRoomUserView.nextViewId += 1;
        this.segmentedControlContainer = createDivIn(this.difficultyContainer, 'room-bot-difficulty-segmentedcontrol', segmentedControlId);
        this.botDifficultyLabel = createSpanIn(this.difficultyContainer, 'room_player_difficulty_badge hidden', {
            key: 'strings:colonistCommon.utils.emptyString'
        });
    }
    renderReadinessState() {
        this.actionIconsContainer = createDivIn(this.readyContainer, 'room-player-actions-container');
        this.readinessContainer = createDivIn(this.readyContainer, 'room_player_ready');
        this.statusText = createSpanIn(this.readinessContainer, '', {
            key: 'strings:roomPage.notReady'
        });
    }
    createAddBotButton() {
        this.addBotButton = createDivIn(this.container, 'btn_general btn_add_bot', 'add-bot-button');
        createImgIn(this.addBotButton, LobbyImage.Bot);
        createSpanIn(this.addBotButton, '', {
            key: 'strings:roomPage.addBot'
        });
        setElementOnClick(this.addBotButton, ()=>{
            AudioManager.play(AudioType.Click);
            socket.roomClient.addBot();
        });
    }
    removePlayer() {
        this.infoContainer.style.display = 'none';
        this.readyContainer.style.display = 'none';
        this.addBotButton.style.display = 'flex';
        this.state = undefined;
        // eslint-disable-next-line no-restricted-syntax
        this.container.onclick = ()=>undefined;
    }
    update(newState) {
        if (this.colorChanged(newState)) this.updateColor(newState.selectedColor);
        this.updateKarma(newState);
        if (this.statusChanged(newState)) this.updateStatus(newState);
        if (this.statusChanged(newState)) this.updateReadyContainerClass(newState);
        this.state = newState;
        this.updateProfilePic();
        this.updateUsernameInfoIcon();
        this.showPlayer();
    }
    updateProfilePic() {
        if (this.state == undefined) return;
        var _this_state_profilePictureUrl;
        const imgPath = (_this_state_profilePictureUrl = this.state.profilePictureUrl) !== null && _this_state_profilePictureUrl !== void 0 ? _this_state_profilePictureUrl : getLobbyImagePath(this.state.icon);
        if (this.profilePic.src != imgPath) this.profilePic.src = imgPath;
        this.profilePic.classList.toggle('profile-picture', this.state.profilePictureUrl != undefined);
    }
    updateActionIcons(icons) {
        setElementInnerHTML(this.actionIconsContainer, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        for (const icon of icons){
            const imageContainer = createDivIn(this.actionIconsContainer, 'room-player-action-icon-container');
            const img = createImgIn(imageContainer, icon.icon, 'darken-on-hover');
            if (icon.action != undefined) {
                const action = icon.action;
                setElementOnClick(img, ()=>action(), false, true);
            }
            if (icon.tooltip == undefined) continue;
            if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) continue;
            createTooltipIn(imageContainer, icon.tooltip);
        }
    }
    updateColor(color) {
        if (color == PlayerColor.None) {
            this.colorRoad.src = IconHourglass;
            this.colorSettlement.src = IconHourglass;
            this.colorCity.src = IconHourglass;
            return;
        }
        this.colorRoad.src = UIImagePathController.roadsByColor[color];
        this.colorSettlement.src = UIImagePathController.settlementsByColor[color];
        this.colorCity.src = UIImagePathController.citiesByColor[color];
    }
    updateKarma(state) {
        if (state.isBot) {
            this.karmaContainer.style.display = 'none';
            return;
        }
        if (state.profilePictureUrl != undefined) {
            this.karmaContainer.style.display = 'none';
            return;
        }
        setElementInnerHTML(this.karmaText, {
            key: 'strings:homePage.header.playerKarma',
            options: {
                totalCompleted: state.karmaCompletedGames,
                totalGames: state.karmaTotalGames
            }
        });
        updateTooltipText(this.karmaContainer, {
            key: 'strings:roomPage.karmaPlayerTooltip'
        });
        this.karmaContainer.style.display = 'flex';
    }
    setBotDifficultyVisibility(visible) {
        this.difficultyContainer.classList.toggle('hidden', !visible);
    }
    renderBotDifficultyAsSegmentedControl(botDifficulty, onTabChange) {
        this.botDifficultyLabel.classList.add('hidden');
        this.segmentedControlContainer.classList.remove('hidden');
        if (this.botDifficultySegmentedControlView == undefined) {
            this.botDifficultySegmentedControlView = mountUIReactComponent(this.segmentedControlContainer.id, SegmentedControl);
        }
        this.botDifficultySegmentedControlView.render({
            size: 'sm',
            activeId: botDifficulty,
            options: [
                {
                    id: BotDifficulty.BotEasy,
                    label: {
                        key: 'strings:roomPage.botDifficulty.segmentedControl.easy'
                    }
                },
                {
                    id: BotDifficulty.BotMedium,
                    label: {
                        key: 'strings:roomPage.botDifficulty.segmentedControl.medium'
                    }
                },
                {
                    id: BotDifficulty.BotHard,
                    label: {
                        key: 'strings:roomPage.botDifficulty.segmentedControl.hard'
                    }
                }
            ],
            onTabChange: onTabChange
        });
    }
    renderBotDifficultyAsBadge(botDifficulty) {
        this.segmentedControlContainer.classList.add('hidden');
        this.botDifficultyLabel.classList.remove('hidden');
        const BOT_DIFFICULTY_LABEL_KEYS = {
            [BotDifficulty.BotEasy]: 'strings:roomPage.botDifficulty.label.easy',
            [BotDifficulty.BotMedium]: 'strings:roomPage.botDifficulty.label.medium',
            [BotDifficulty.BotHard]: 'strings:roomPage.botDifficulty.label.hard'
        };
        setElementInnerHTML(this.botDifficultyLabel, {
            key: BOT_DIFFICULTY_LABEL_KEYS[botDifficulty]
        });
    }
    setUsername(username) {
        setElementInnerHTML(this.userName, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: ` ${username} `
            }
        });
    }
    updateStatus(state) {
        if (state.isReadyToPlay) {
            this.statusText.innerText = clientI18n.t('strings:roomPage.ready').toLocaleUpperCase();
            this.container.classList.remove('room_player_name_not_ready');
            return;
        }
        this.statusText.innerText = clientI18n.t('strings:roomPage.notReady');
        this.container.classList.add('room_player_name_not_ready');
    }
    updateReadyContainerClass(state) {
        if (state.isReadyToPlay) this.readyContainer.classList.remove('room_player_not_ready_color');
        else this.readyContainer.classList.add('room_player_not_ready_color');
    }
    showPlayer() {
        this.infoContainer.style.display = 'flex';
        this.readyContainer.style.display = 'flex';
        this.hideBotButton();
    }
    setColorOnclick(action) {
        setElementOnClick(this.colorContainer, ()=>{
            AudioManager.play(AudioType.Click);
            action();
        });
    }
    setOnclick(action) {
        // eslint-disable-next-line no-restricted-syntax
        this.container.onclick = (e)=>{
            if (e.target == this.colorContainer) return;
            AudioManager.play(AudioType.Click);
            action();
        };
    }
    toggleColorSelector(show) {
        if (show) {
            this.colorContainer.classList.add('can_edit_color');
            return;
        }
        this.colorContainer.classList.remove('can_edit_color');
    }
    hideView() {
        if (this.container.style.display == 'none') return;
        this.container.style.display = 'none';
    }
    showView() {
        if (this.container.style.display == 'flex') return;
        this.container.style.display = 'flex';
    }
    displayBotButton() {
        if (this.state != undefined) return;
        this.addBotButton.style.display = 'flex';
    }
    hideBotButton() {
        this.addBotButton.style.display = 'none';
    }
    showUsernameInfoIcon() {
        this.usernameInfoIcon.style.display = 'inherit';
    }
    hideUsernameInfoIcon() {
        this.usernameInfoIcon.style.display = 'none';
    }
    isShowingPlayer() {
        return this.infoContainer.style.display == 'flex';
    }
    enableHover() {
        this.container.classList.add('hover-enabled');
    }
    disableHover() {
        this.container.classList.remove('hover-enabled');
    }
    updateUsernameInfoIcon() {
        if (this.shouldShowUsernameInfoIcon()) {
            this.showUsernameInfoIcon();
        } else {
            this.hideUsernameInfoIcon();
        }
    }
    shouldShowUsernameInfoIcon() {
        var _this_state;
        if (!UIUtilsEjsVariables.isUserOnDiscord) return false;
        if (((_this_state = this.state) === null || _this_state === void 0 ? void 0 : _this_state.profilePictureUrl) != undefined) return false;
        return this.isItMe();
    }
    colorChanged(newState) {
        if (this.state == undefined) return true;
        return this.state.selectedColor != newState.selectedColor;
    }
    statusChanged(newState) {
        if (this.state == undefined) return true;
        return this.state.isReadyToPlay != newState.isReadyToPlay;
    }
    static createIconIn(container, icon, size) {
        const img = createImgIn(container, icon);
        img.width = size;
        img.height = size;
        return img;
    }
    isItMe() {
        if (this.state == undefined) return false;
        return UIRoomUserList.isItMe(this.state);
    }
    constructor(container){
        this.PLAYER_ICON_SIZE = 28;
        this.ACTION_ICON_SIZE = 18;
        this.ICON_SIZE = 17;
        this.container = createDivIn(container, 'room_player_name');
        this.infoContainer = createDivIn(this.container, 'room_player_info');
        this.readyContainer = createDivIn(this.container, 'room_player_ready_container room_player_not_ready_color');
        this.nameContainer = createDivIn(this.infoContainer, 'room_player_user');
        this.colorAndDifficultyRow = createDivIn(this.infoContainer, 'room_player_color_and_difficulty');
        this.colorContainer = createDivIn(this.colorAndDifficultyRow, 'room_player_color');
        this.renderUserInfo();
        this.colorRoad = UIRoomUserView.createIconIn(this.colorContainer, LobbyImage.RoadBronze, this.ICON_SIZE);
        this.colorSettlement = UIRoomUserView.createIconIn(this.colorContainer, LobbyImage.SettlementBronze, this.ICON_SIZE);
        this.colorCity = UIRoomUserView.createIconIn(this.colorContainer, LobbyImage.CityBronze, this.ICON_SIZE);
        this.createBotDifficultyControl();
        this.renderReadinessState();
        this.createAddBotButton();
        this.removePlayer();
    }
}
UIRoomUserView.nextViewId = 0;
